/**
 * @typedef Config
 * @property {object} channel
 * @property {number} channel.id
 * @property {string} channel.secret
 * @property {string} channel.accessToken
 */
